module.exports = __webpack_public_path__ + "static/media/transportation-black.746bfe2a.svg";